import { render, staticRenderFns } from "./auditFailReason.vue?vue&type=template&id=48cc3236&scoped=true"
import script from "./auditFailReason.vue?vue&type=script&lang=js"
export * from "./auditFailReason.vue?vue&type=script&lang=js"
import style0 from "./auditFailReason.vue?vue&type=style&index=0&id=48cc3236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc3236",
  null
  
)

export default component.exports